import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import StudentContext from '../../context/StudentContext'
import Sidedash from '../uicomponents/Sidedash'
import Editstudents from './Editstudents'
import AlertContext from '../../context/AlertContext'
import { capitalizeFirstLetter } from '../utils/Utilsfunc'
import { copyToClipboard } from '../utils/Utilsfunc'
import ScrollButton from '../uicomponents/ScrollButton'
import LoadingContext from '../../context/LoadingContext'

const Studentlist = (props) => {
    const context = useContext(StudentContext)
    const host = process.env.REACT_APP_BACKEND_URL;
    const [attendanceData, setAttendanceData] = useState([]);
    const { isLoading, setIsLoading } = useContext(LoadingContext);
    const { deleteStudent, editStudent, editStudentAccountStatus } = context;
    const { showAlert } = useContext(AlertContext)
    const editModalRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [student, setStudent] = useState({ id: "", ename: "", eemail: "", egender: "", password: "", eaddress: "", ephone: "", eparentsphone: "", ephoto: "", edocumentid: "", uid: "", erole: "Student", euid: "", eattendanceCode: "" })
    const history = useNavigate()
    const [studentFiles, setStudentFiles] = useState({ ephoto: null, edocumentid: null });
    const [showImage, setShowImage] = useState(null);
    const [editLoader, setEditLoader] = useState(false);
    const styleBackground = {
        backgroundImage: "url('/images/stdbg.jpg')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    }
    const [students, setStudents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const limit = 50;
    const [activeFilter, setActiveFilter] = useState('all');
    const location = useLocation();
    

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
        }, 400); // debounce
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        // On mount, set filter from URL query param
        const params = new URLSearchParams(location.search);
        const urlFilter = params.get('filter');
        if (urlFilter) {
            setActiveFilter(urlFilter);
            setCurrentPage(1); // Reset to first page when filter changes
        }
    }, [location.search]);

    const fetchStudents = useCallback(async (page, search, filter) => {
        try {
            let url = `${host}/students/showall/?page=${page}&limit=${limit}`;
            if (search) url += `&search=${encodeURIComponent(search)}`;
            if (filter && filter !== 'all') url += `&filter=${filter}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token'),
                }
            });
            const data = await response.json();
            setStudents(data.students || []);
            setTotalCount(data.totalCount || 0);
        } catch (error) {
            setStudents([]);
            setTotalCount(0);
        }
    }, [host, limit]);

    const fetchAttendanceData = useCallback(async () => {
        try {
            const response = await fetch(`${host}/attendance/attendance-today`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            if (response.ok) {
                setAttendanceData(data.data);
            } else {
                console.error("Failed to fetch attendance data:", data.error);
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    }, [host]);

    useEffect(() => {
        if (localStorage.getItem('token') && (localStorage.getItem('role') === 'Admin' || localStorage.getItem('role') === 'Superadmin')) {
            setIsLoading(true);
            fetchStudents(currentPage, debouncedSearch, activeFilter).finally(() => setIsLoading(false));
            fetchAttendanceData();
        } else if (localStorage.getItem('role') === 'Student') {
            showAlert("You aren't allowed to be here", "danger")
            history("/account");
        } else {
            showAlert("Please login to continue", "warning")
            history("/login");
        }
    }, [currentPage, debouncedSearch, activeFilter, fetchStudents, fetchAttendanceData, setIsLoading, showAlert, history]);

    const updateStudents = (currentStudent) => {
        // in order to ref the modal from another component
        if (editModalRef.current) {
            editModalRef.current.click();
        }
        setStudent({ 
            id: currentStudent._id, 
            ename: currentStudent.name, 
            eemail: currentStudent.email, 
            egender: currentStudent.gender, 
            password: currentStudent.password, 
            eaddress: currentStudent.address, 
            ephone: currentStudent.phone, 
            eparentsphone: currentStudent.parentsphone, 
            ephoto: currentStudent.photo, 
            edocumentid: currentStudent.documentid, 
            erole: currentStudent.role, 
            euid: currentStudent.uid, 
            eattendanceCode: currentStudent.attendanceCode 
        })
    }


    const handleClickEdit = async (e) => {
        e.preventDefault();
        setEditLoader(true)
        const formData = new FormData();

        formData.append('name', student.ename);
        formData.append('email', student.eemail);
        formData.append('gender', student.egender);
        formData.append('address', student.eaddress);
        formData.append('phone', student.ephone);
        formData.append('parentsphone', student.eparentsphone);
        formData.append('role', student.erole);
        formData.append('accountStatus', student.eaccountStatus);

        // Append text fields to formData only if they have been explicitly set
        Object.keys(student).forEach(key => {
            if (student[key] !== undefined && key !== 'password' && key !== 'accountStatus') {
                formData.append(key, student[key]);
            }
        });

        // Add file fields if they exist
        if (studentFiles.ephoto) {
            formData.append('photo', studentFiles.ephoto);
        }
        if (studentFiles.edocumentid) {
            formData.append('documentid', studentFiles.edocumentid);
        }

        try {
            const response = await editStudent(student.id, formData);
            // console.log(response.message, "hihello")
            if (response.success) {
                setEditLoader(false)
                //console.log("Successfully updated student 1:", response.updatedStudent);
                // Perform additional UI updates here, if necessary
                showAlert(`Update successful! ${response.updatedStudent.name}`, "success")
            } else {
                console.error("Failed to update student:", response.message);
                showAlert(`Error uploading photos: ${response.error}`, "danger")
                // Handle error UI feedback here
            }
        } catch (error) {
            console.error("Unexpected error:", error);
            // Handle unexpected errors here
            showAlert(`Error uploading photos: ${error.message}`, "danger")
        }
    }

    const toggleAccountStatus = (e, id, currentAccountStatus) => {
        e.preventDefault();
        const newAccountStatus = currentAccountStatus === true ? false : true;
        editStudentAccountStatus(id, newAccountStatus);
        //console.log("Updating account status to:", newAccountStatus);
    };

    const onChangeEdit = (e) => {
        if (e.target.type === 'file') {
            setStudentFiles({ ...studentFiles, [e.target.name]: e.target.files[0] });
        } else {
            setStudent({ ...student, [e.target.name]: e.target.value });
        }
    };
    const copyTheUid = (uid) => {
        copyToClipboard(`studentuid-${uid}`)
        showAlert("UID copied to clipboard", "success")
    }

    // Attendance -------------------------------------
    // Determine student attendance status
    const getAttendanceStatus = (studentId) => {
        const record = attendanceData.find(att => att.studentId === studentId);
        if (!record) return "absent";
        // If there's no record, it means no check-in => "absent" (or return null if you prefer)

        return record.status;
        // returns "online" or "offline"
    };
    // Attendance -------------------------------------

    // Pagination controls
    const totalPages = Math.ceil(totalCount / limit);
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

    // checking if uploaded file uploaded is pdf
    const isImageFile = (fileUrl) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        const fileExtension = fileUrl.split('.').pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
    };

    return (
        <>
            <div className="container-fluid">
                <ScrollButton />
                <div className="row">
                    <Sidedash
                        onSetAll={() => { setActiveFilter('all'); setCurrentPage(1); }}
                        onSetActive={() => { setActiveFilter('active'); setCurrentPage(1); }}
                        onSetInactive={() => { setActiveFilter('inactive'); setCurrentPage(1); }}
                        onSetExpired={() => { setActiveFilter('expired'); setCurrentPage(1); }}
                        onSetHasBooking={() => { setActiveFilter('hasBooking'); setCurrentPage(1); }}
                        onSetOnline={() => { setActiveFilter('online'); setCurrentPage(1); }}
                        onSetOffline={() => { setActiveFilter('offline'); setCurrentPage(1); }}
                        onSetAbsent={() => { setActiveFilter('absent'); setCurrentPage(1); }}
                    />

                    <div className="col-md-9 pt-3">
                        <div className="row">
                            <div className='col-md-12 position-relative mb-1'>
                                <div className="search-wrapper">
                                    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <path d="m21 21-4.35-4.35"></path>
                                    </svg>
                                    <input
                                        type="text"
                                        className="form-control search-input"
                                        placeholder="Search by name, UID, email or phone..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)} />
                                    {searchTerm && (
                                        <button
                                            className="btn btn-clear-search"
                                            type="button"
                                            onClick={() => setSearchTerm('')}
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* =======================placeholder============================== */}

                            {isLoading ? (
                                <>

                                    <div className="col-md-4 col-xl-4">
                                        <div className="card mb-3" aria-hidden="true" style={{ backgroundImage: `url("/images/stdbg.jpg")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }}>
                                            <div className="card-body text-center placeholder-glow">
                                                <span className="img-fluid placeholder rounded-circle mb-2 card-img-top" width="128" height="128" style={{ display: 'inline-block', background: '#8a8f90', height: 128, width: 128 }} ></span>
                                                <h5 className="card-title mb-0 placeholder-glow"><span className="placeholder col-5"></span></h5>
                                                <div className="text-muted mb-2 position-relative placeholder-glow">
                                                    <span id="studentuid-2411DI183"><span className="placeholder col-3"></span></span>

                                                </div>
                                                <div><span className="placeholder-glow btn btn-primary btn-sm"><span className="placeholder col-5"></span></span></div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body position-relative">
                                                <span className="collapsible position-relative placeholder-glow">
                                                    <h5 className="h6 card-title cursor-pointer" data-bs-toggle="collapse" data-bs-target="#T2411DI183" aria-controls="T2411DI183"><span className="placeholder col-5"></span></h5>

                                                </span>
                                                <div className="collapse " id="T2411DI183">
                                                    <ul className="list-group">
                                                        <p className='placeholder-glow'><span className="placeholder col-4"></span></p>
                                                    </ul>
                                                </div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#C2411DI183" aria-controls="C2411DI183"><span className="placeholder col-3"></span></h5>

                                                </span>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#P2411DI183" aria-controls="P2411DI183"><span className="placeholder col-6"></span></h5>

                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-xl-4">
                                        <div className="card mb-3" aria-hidden="true" style={{ backgroundImage: `url("/images/stdbg.jpg")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }}>
                                            <div className="card-body text-center placeholder-glow">
                                                <span className="img-fluid placeholder rounded-circle mb-2 card-img-top" width="128" height="128" style={{ display: 'inline-block', background: '#8a8f90', height: 128, width: 128 }} ></span>
                                                <h5 className="card-title mb-0 placeholder-glow"><span className="placeholder col-5"></span></h5>
                                                <div className="text-muted mb-2 position-relative placeholder-glow">
                                                    <span id="studentuid-2411DI183"><span className="placeholder col-3"></span></span>

                                                </div>
                                                <div><span className="placeholder-glow btn btn-primary btn-sm"><span className="placeholder col-5"></span></span></div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body position-relative">
                                                <span className="collapsible position-relative placeholder-glow">
                                                    <h5 className="h6 card-title cursor-pointer" data-bs-toggle="collapse" data-bs-target="#T2411DI183" aria-controls="T2411DI183"><span className="placeholder col-5"></span></h5>

                                                </span>
                                                <div className="collapse " id="T2411DI183">
                                                    <ul className="list-group">
                                                        <p className='placeholder-glow'><span className="placeholder col-4"></span></p>
                                                    </ul>
                                                </div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#C2411DI183" aria-controls="C2411DI183"><span className="placeholder col-3"></span></h5>

                                                </span>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#P2411DI183" aria-controls="P2411DI183"><span className="placeholder col-6"></span></h5>

                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-xl-4">
                                        <div className="card mb-3" aria-hidden="true" style={{ backgroundImage: `url("/images/stdbg.jpg")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }}>
                                            <div className="card-body text-center placeholder-glow">
                                                <span className="img-fluid placeholder rounded-circle mb-2 card-img-top" width="128" height="128" style={{ display: 'inline-block', background: '#8a8f90', height: 128, width: 128 }} ></span>
                                                <h5 className="card-title mb-0 placeholder-glow"><span className="placeholder col-5"></span></h5>
                                                <div className="text-muted mb-2 position-relative placeholder-glow">
                                                    <span id="studentuid-2411DI183"><span className="placeholder col-3"></span></span>

                                                </div>
                                                <div><span className="placeholder-glow btn btn-primary btn-sm"><span className="placeholder col-5"></span></span></div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body position-relative">
                                                <span className="collapsible position-relative placeholder-glow">
                                                    <h5 className="h6 card-title cursor-pointer" data-bs-toggle="collapse" data-bs-target="#T2411DI183" aria-controls="T2411DI183"><span className="placeholder col-5"></span></h5>

                                                </span>
                                                <div className="collapse " id="T2411DI183">
                                                    <ul className="list-group">
                                                        <p className='placeholder-glow'><span className="placeholder col-4"></span></p>
                                                    </ul>
                                                </div>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#C2411DI183" aria-controls="C2411DI183"><span className="placeholder col-3"></span></h5>

                                                </span>
                                            </div>
                                            <hr className="my-0" />
                                            <div className="card-body">
                                                <span className="collapsible position-relative">
                                                    <h5 className="h6 card-title cursor-pointer placeholder-glow" data-bs-toggle="collapse" data-bs-target="#P2411DI183" aria-controls="P2411DI183"><span className="placeholder col-6"></span></h5>

                                                </span>
                                            </div>
                                        </div>
                                    </div>





                                </>



                            ) : ("")}

                            {/* =======================placeholder============================== */}

                            {/* {filteredStudents.length === 0 && "No user found! WTF!!!"} */}
                            {students.map((student) => {
                                const dateString = student.regisDate;
                                const date = new Date(dateString);
                                //gets random avatars
                                const avatarFilename = student.avatar;
                                const attendanceStatus = getAttendanceStatus(student._id);
                                return (
                                    <>
                                        <div key={student._id} className="col-md-6 col-xl-4">
                                            <div className="card student-card mb-4 shadow-sm" style={styleBackground} >
                                                <div className="card-body text-center student-header">
                                                    <div className="student-avatar-wrapper mb-3">
                                                        <img src={`/images/${avatarFilename}.jpg`} alt={student.name} className="student-avatar" width="120" height="120" />
                                                        {attendanceStatus === "Online" && <span className="attendance-badge online"><span className="pulse"></span></span>}
                                                        {attendanceStatus === "Offline" && <span className="attendance-badge offline"></span>}
                                                    </div>
                                                    <h5 className="student-name mb-1">
                                                        {student.name}
                                                    </h5>
                                                    <div className="student-uid mb-2">
                                                        <span id={`studentuid-${student.uid}`} className="uid-text">{student.uid}</span>
                                                        <button className="btn-copy-uid" onClick={() => copyTheUid(student.uid)} title="Copy UID">
                                                            <svg width="14" height="14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                            </svg>
                                                        </button>
                                                    </div>

                                                    <div className="student-actions d-flex gap-2 justify-content-center flex-wrap">
                                                        <button className="btn btn-action btn-edit" onClick={() => { updateStudents(student) }}>
                                                            <svg width="14" height="14" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>
                                                            Edit
                                                        </button>

                                                        {(student.role === "Superadmin") ? "" :
                                                            <>
                                                                <button className={`btn btn-action ${student.accountStatus ? 'btn-active' : 'btn-inactive'}`} onClick={(e) => toggleAccountStatus(e, student._id, student.accountStatus)}>
                                                                    {student.accountStatus ? "Active" : "Inactive"}
                                                                </button>
                                                                {(localStorage.getItem('role') === 'Admin') ? "" :
                                                                    <>
                                                                        <button className="btn btn-action btn-sm btn-delete" onClick={(e) => { deleteStudent(student._id); showAlert(`${student.name} deleted successfully`, "danger") }}>
                                                                            <svg width="14" height="14" fill="currentColor" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                                                                            Delete
                                                                        </button>
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="card-divider"></div>
                                                <div className="card-body card-section">
                                                    <span className='collapsible position-relative'>
                                                        <h6 className="section-title cursor-pointer" data-bs-toggle="collapse" data-bs-target={`#T${student.uid}`} aria-controls={`T${student.uid}`}>
                                                            <svg className="section-icon" width="16" height="16" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"/></svg>
                                                            Seat Details
                                                        </h6>
                                                        <svg className="collapse-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" /></svg>
                                                    </span>
                                                    <div className={`collapse ${student.seatAssigned.length > 0 ? "show" : ""}`} id={`T${student.uid}`}>
                                                        <div className='info-list mt-2'>
                                                            {
                                                                //show booked shifts
                                                                student.seatAssigned && student.seatAssigned.length > 0 ? (
                                                                    student.seatAssigned.map((shift, index) => (

                                                                        //checking validity date

                                                                        <div className={`info-item ${(new Date(shift.validityDate) < new Date().setHours(0, 0, 0, 0) ? "expired" : "")}`} key={index}>
                                                                            <span className="seat-badge">Seat {shift.seatNumber}</span>
                                                                            <span className="slot-badge">{capitalizeFirstLetter(shift.slot)}</span>
                                                                            <span className="validity-text">Valid: {shift.validityDate}</span>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <p className="no-data-text">No booked shifts</p>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-divider"></div>
                                                <div className="card-body card-section">

                                                    <span className='collapsible position-relative'>
                                                        <h6 className="section-title cursor-pointer" data-bs-toggle="collapse" data-bs-target={`#C${student.uid}`} aria-controls={`C${student.uid}`}>
                                                            <svg className="section-icon" width="16" height="16" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.6 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/></svg>
                                                            About
                                                        </h6>
                                                        <svg className="collapse-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" /></svg>
                                                    </span>
                                                    <div className="collapse" id={`C${student.uid}`}>
                                                        <div className="info-list mt-2">
                                                            <div className="info-item">
                                                                <svg className="info-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 576 512"><path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z" /></svg>
                                                                <div className="info-content">
                                                                    <span className="info-label">Address</span>
                                                                    <span className="info-value">{student.address}</span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <svg className="info-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z" /></svg>
                                                                <div className="info-content">
                                                                    <span className="info-label">Email</span>
                                                                    <span className="info-value">{student.email}</span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <svg className="info-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 512 512"><path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" /></svg>
                                                                <div className="info-content">
                                                                    <span className="info-label">Phone</span>
                                                                    <span className="info-value">{student.phone}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-divider"></div>
                                                <div className="card-body card-section">
                                                    <span className='collapsible position-relative'>
                                                        <h6 className="section-title cursor-pointer" data-bs-toggle="collapse" data-bs-target={`#P${student.uid}`} aria-controls={`P${student.uid}`}>
                                                            <svg className="section-icon" width="16" height="16" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/></svg>
                                                            Other Details
                                                        </h6>
                                                        <svg className="collapse-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" /></svg>
                                                    </span>
                                                    <div className="collapse" id={`P${student.uid}`}>
                                                        <div className="info-list mt-2">
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Role</span>
                                                                    <span className="info-value">{student.role}</span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Attendance Code</span>
                                                                    <span className="info-value fw-bold">{student.attendanceCode}</span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Registered on</span>
                                                                    <span className="info-value">{`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`}</span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Photo</span>
                                                                    <span className="info-value">
                                                                        {showImage === `${student.uid}-doc` ?
                                                                            <>
                                                                                <button className="btn btn-sm btn-secondary me-2 mb-2" onClick={() => setShowImage(null)}>Hide</button>
                                                                                {isImageFile(student.photo) ?
                                                                                    <img src={student.photo} alt={`ID-${student.name.replace(/\s/g, '')}`} style={{ width: '100%', borderRadius: '8px', marginTop: '8px' }} /> :
                                                                                    <a href={student.photo} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">View Document</a>
                                                                                }
                                                                            </> :
                                                                            <button className="btn btn-sm btn-primary" onClick={() => setShowImage(`${student.uid}-doc`)}>Show</button>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Document ID</span>
                                                                    <span className="info-value">
                                                                        {showImage === `${student.uid}-doc` ?
                                                                            <>
                                                                                <button className="btn btn-sm btn-secondary me-2 mb-2" onClick={() => setShowImage(null)}>Hide</button>
                                                                                {isImageFile(student.documentid) ?
                                                                                    <a href={student.documentid}>
                                                                                        <img src={student.documentid} alt={`Document-Id-${student.name.replace(/\s/g, '')}`} style={{ width: '100%', borderRadius: '8px', marginTop: '8px' }} />
                                                                                    </a> :
                                                                                    <a href={student.documentid} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">View Document</a>
                                                                                }

                                                                            </> :
                                                                            <button className="btn btn-sm btn-primary" onClick={() => setShowImage(`${student.uid}-doc`)}>Show</button>
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="info-item">
                                                                <div className="info-content">
                                                                    <span className="info-label">Parent's Phone</span>
                                                                    <span className="info-value">{student.parentsphone}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>
                        {/* Pagination controls */}
                        {totalPages > 1 && (
                            <nav className="mt-4">
                                <ul className='pagination pagination-modern justify-content-center'>
                                    {pageNumbers.map(number => (
                                        <li key={number} className={`page-item${number === currentPage ? ' active' : ''}`}>
                                            <button type="button" onClick={(e) => {
                                                e.preventDefault();
                                                setCurrentPage(number);
                                            }} className='page-link'>
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
            </div>
            <Editstudents key={student._id} ref={editModalRef} editLoader={editLoader} student={student} onChangeEdit={onChangeEdit} handleClickEdit={handleClickEdit} />
        </>
    )
}

export default Studentlist